import script from "./TestingInProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./TestingInProgress.vue?vue&type=script&setup=true&lang=js"

import "./TestingInProgress.vue?vue&type=style&index=0&id=2e9c1255&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e9c1255"]])

export default __exports__